import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import '../../App.css'
import '../../style.css';
import {OPENING_CONTAINER_BOX_SX   ,
        OPENING_SCREEN_PAPER_SX    ,
        OPENING_TITLE_MAIN_SX      ,
        OPENING_TITLE_SUB_SX       ,
        OPENING_TITLE_VERSION_SX   ,
        OPENING_START_TEXT_SX      ,
        OPENING_RED_IMG_STYLE      ,
        OPENING_HITOKAGE_IMG_STYLE ,
        OPENING_COPYRIGHT_TEXT_SX  , } from '../Style/OpeningUIStyle'
import {baseId,
        IMG_OPENING_RED,
        IMG_OPENING_HITOKAGE,} from '../Contants'

function GBOpening() {
  return (
    <Box sx={OPENING_CONTAINER_BOX_SX}>
      {/* 画面 */}
      <Paper sx={OPENING_SCREEN_PAPER_SX}>
        <Grid container spacing={0}>
          {/* タイトル表示 */}
          <Grid item xs={12} align="center">
            <Typography sx={OPENING_TITLE_MAIN_SX}>
              ポケットモンスター
            </Typography>
          </Grid>

          <Grid item xs={12} align="center">
            <Typography sx={OPENING_TITLE_SUB_SX}>
              POKET MONSTERS
            </Typography>
          </Grid>

          <Grid item xs={12} align="center">
            <Typography sx={OPENING_TITLE_VERSION_SX}>
              Red Version
            </Typography>
          </Grid>

          <Grid item xs={12} align="center">
            <Typography
              className="blinking-text" // 点滅するクラス
              sx={OPENING_START_TEXT_SX}
            >
              Start ボタンをおしてね
            </Typography>
          </Grid>

          {/* レッドの画像表示 */}
          <Grid item xs={6} align="right">
            <img
              src={IMG_OPENING_RED}
              style={OPENING_RED_IMG_STYLE}
            />
          </Grid>

          {/* ヒトカゲの画像表示 */}
          <Grid item xs={6} align="left">
            <img
              src={IMG_OPENING_HITOKAGE}
              style={OPENING_HITOKAGE_IMG_STYLE}
            />
          </Grid>

          <Grid item xs={12} align="center">
            <Typography sx={OPENING_COPYRIGHT_TEXT_SX}>
              @1995 GAME FREAK Inc.
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={2}>
        <Grid item xs={12} align="center"></Grid>
      </Grid>
    </Box>
  );
}

export default GBOpening;